const GUEST_ASSISTANT_RETURN_PATHS = [
  "/events/search",
  "/events/map_search",
  "/clubs",
];

function isAllowedGuestAssistantReturnPath(path) {
  const value = String(path || "").trim();
  return GUEST_ASSISTANT_RETURN_PATHS.some(
    (basePath) =>
      value === basePath ||
      value.startsWith(`${basePath}?`) ||
      value.startsWith(`${basePath}#`)
  );
}

export function buildAssistantReturnPath(location) {
  const pathname = String(location?.pathname || "").trim();
  const search = String(location?.search || "");
  const hash = String(location?.hash || "");
  const candidate = `${pathname}${search}${hash}`;
  return isAllowedGuestAssistantReturnPath(candidate)
    ? candidate
    : "/events/search";
}

export function resolveAssistantBackPath({ isGuest = false, state = null } = {}) {
  if (!isGuest) return "/menu/chats";
  const returnPath = String(state?.assistantReturnTo || "").trim();
  return isAllowedGuestAssistantReturnPath(returnPath)
    ? returnPath
    : "/events/search";
}

